module.exports = __webpack_public_path__ + "static/media/vail-18.a0660ee9.jpg";